export default "__VITE_ASSET__MO7Q0psn__"